import React, { useState, useEffect, useMemo, Children } from "react";
import { Tabs, Modal, Spin, Switch, Button, Collapse, Row } from "antd";
import { getRequest } from "../../../../api/http";
import userServiceApi from "../../../../api/userServiceApi";
import { toast } from "react-toastify";
import "../index.scss";
import ReactPlayer from "react-player/youtube";
import { TAB_KEYS } from "../../../../config";
import { useMicrosite } from "../../../../custom-hooks/useMicrosite";
import { useStore } from "../../../../store";
import leftArrow from "../../../../assets/images/Path3954.png";
import rightArrow from "../../../../assets/images/Path3900.png";
import VimeoPlayer from "react-player";
import Slider from "react-slick";
import "../../../microsite-accordian/style.scss";
import "./previewTab.scss"
import Reviews from "../tabs/contact-us/sub-tabs/reviews";
import watsapp from "../../../../assets/images/watsapp.svg";
import phoneIc from "../../../../assets/images/phone.svg";
import Website from "../../../../assets/images/website.svg";
import mail from "../../../../assets/images/mail.svg";
import twitter from "../../../../assets/images/twitter.svg";
import linkedin from "../../../../assets/images/linkedIn.svg";
import youtube from "../../../../assets/images/youtube.svg";
import tiktok from "../../../../assets/images/tiktok.svg";
import instagram from "../../../../assets/images/instagram.svg";
import facebook from "../../../../assets/images/facebook-icon.svg";
import { PreviewTab } from "./PreviewTabs/PreviewTab";
import { DynamicTab } from "./PreviewTabs/DynamicTab";
import { PreviewContactUs } from "./PreviewTabs/PreviewContactUs";
import { AboutUsPreviewTab } from "./PreviewTabs/AboutUsPreviewTab";

const tabList = [
  {
    tabName: "About Us",
    tabKey: TAB_KEYS.aboutUs,
    settingsKey: 'about-us',
  },
  {
    tabName: "Products",
    tabKey: 'products',
    settingsKey: "products",
  },
  {
    tabName: "Services",
    tabKey: TAB_KEYS.service,
    settingsKey: "services",
  },
  {
    tabName: "Vacancies",
    tabKey: "vacancies",
    settingsKey: "vacancies",
  },
  {
    tabName: "Apprenticeships",
    tabKey: "apprenticeship",
    settingsKey: "apprenticeships",
  },
  {
    tabName: "Our Teams and Roles",
    tabKey: "teams-and-roles",
    settingsKey: "teams-and-roles",
  },

  {
    tabName: "Courses",
    tabKey: "courses",
    settingsKey: "courses",
  },

  {
    tabName: "Experiences of work",
    tabKey: TAB_KEYS.workExperience,
    settingsKey: "experiences-of-work",
  },

  {
    tabName: "Why work for us",
    tabKey: "why-work",
    settingsKey: "why-work",
  },
  {
    tabName: "Contracts",
    tabKey: TAB_KEYS.contract,
    settingsKey: "contracts",
  },


  {
    tabName: "Contact Us",
    tabKey: TAB_KEYS.contactUs,
    settingsKey: 'contact-us',
  },
];


const CompLoader = () => {
  return (
    <div className="data-loader-alt">
      <Spin tip="Loading" size="small" />
    </div>
  );
};

const ContactUSComp = ({ data }) => {
  return (
    <div className="preview-congtact-item">
      <div className="preview--contact-item-container">
        <div className="gutter-row tabContent" span={15}>
          <img src={phoneIc} alt="Image" style={{ marginRight: "3px" }} />
          Phone
        </div>
        <div className="gutter-row tabContent-body" span={15}>
          {data.phone}
        </div>
      </div>
      <div className="preview--contact-item-container">
        <div className="gutter-row tabContent" span={15}>
          <img src={mail} alt="Image" style={{ marginRight: "3px" }} />
          Email
        </div>
        <div className="gutter-row tabContent-body" span={15}>
          {data.email}
        </div>
      </div>
      <div className="preview--contact-item-container">
        <div className="gutter-row tabContent" span={15}>
          <img src={watsapp} alt="Image" style={{ marginRight: "3px" }} />
          Whatsapp
        </div>
        <div className="gutter-row tabContent-body" span={15}>
          {data.chatNumber}
        </div>
      </div>
      <div className="preview--contact-item-container">
        <div className="gutter-row tabContent" span={15}>
          <img src={Website} alt="Image" style={{ marginRight: "3px" }} />
          Website
        </div>
        <div className="gutter-row tabContent-body" span={15}>
          <a href={data.websiteLink}> {data.websiteLink} </a>
        </div>
      </div>
    </div>
  );
};

const ContactUSSocialMedia = ({ data }) => {
  return (
    <div className="preview-congtact-item">
      {data.linkedInLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={linkedin} alt="Image" style={{ marginRight: "3px" }} />
            Linkedin
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.linkedInLink} target="_blank">
              {data.linkedInLink}
            </a>
          </div>
        </div>
      ) : null}
      {data.twitterLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={twitter} alt="Image" style={{ marginRight: "3px" }} />X
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.twitterLink} target="_blank">
              {data.twitterLink}
            </a>
          </div>
        </div>
      ) : null}
      {data.youtubeLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={youtube} alt="Image" style={{ marginRight: "3px" }} />
            Youtube
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.youtubeLink} target="_blank">
              {data.youtubeLink}
            </a>
          </div>
        </div>
      ) : null}
      {data.instagramLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={instagram} alt="Image" style={{ marginRight: "3px" }} />
            Instagram
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.instagramLink} target="_blank">
              {data.instagramLink}
            </a>
          </div>
        </div>
      ) : null}
      {data.tiktokLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={tiktok} alt="Image" style={{ marginRight: "3px" }} />
            Tik-Tok
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.tiktokLink} target="_blank">
              {data.tiktokLink}
            </a>
          </div>
        </div>
      ) : null}
      {data.facebookLink ? (
        <div className="preview--contact-item-container">
          <div className="gutter-row tabContent tab-heading-preview">
            <img src={facebook} alt="Image" style={{ marginRight: "3px" }} />
            Facebook
          </div>
          <div className="gutter-row tabContent-body">
            <a href={data.facebookLink} target="_blank">
              {data.facebookLink}
            </a>
          </div>
        </div>
      ) : null}
    </div>
  );
};

function Preview({ closeSettings, siteSetting, micrositeId, data }) {
  const { publishMicroSite, microSitePublishLoading } = useMicrosite();

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("about-us");
  const [contactUsKey, setContactUsKey] = useState("REVIEWS");
  const [responseData, setReponseData] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [mediatype, setmediatype] = useState("");

  const [switchState, setSwitchState] = useState(data.published);
  const [publishConfirmation, setPublishConfirmation] = useState(false);
  const [unPublishConfirmation, setUnPublishConfirmation] = useState(false);


  const [carouselData, setCData] = useState([]);
  const [cLoader, setCLoader] = useState(false);
  const [position, setPosition] = useState(["left", "right"]);
  const color = [
    "#E75E0D",
    "#EB9F11",
    "#ABC710",
    "#009340",
    "#CC0370",
    "#8366A9",
    "#149BD7",
  ];

  const { microSites, proSettingData } = useStore();

  const renderTabContent = (key) => {
    switch (key) {
      case "services":
      case "products":
      case "vacancies":
      case "apprenticeships":
      case "courses":
      case "experiences-of-work":
      case "why-work":
      case "contracts":
      case 'business-card':
      case "home-carousel":
      case "in-the-press":
      case "blog":
      case "why-work-for-us":
      case "teams-and-roles":
        return <PreviewTab PreviewTab responseData={responseData} PlayVimeoVideoHandler={PlayVimeoVideoHandler} convertToStandardURL={convertToStandardURL} PlayVideoHandler={PlayVideoHandler} loading={loading} CompLoader={CompLoader} color={color} />;
      case "about-us":
        return <AboutUsPreviewTab AboutUsPreviewTab responseData={responseData} PlayVimeoVideoHandler={PlayVimeoVideoHandler} convertToStandardURL={convertToStandardURL} PlayVideoHandler={PlayVideoHandler} loading={loading} CompLoader={CompLoader} color={color} />;
      case "contact-us":
        return <PreviewContactUs PreviewContactUs changeContactUsTab={changeContactUsTab} contactUsKey={contactUsKey} responseData={responseData} activeKey={activeKey} loading={loading} CompLoader={CompLoader} ContactUSComp={ContactUSComp} ContactUSSocialMedia={ContactUSSocialMedia} Reviews={Reviews} />;
      case "items":
        return <DynamicTab DynamicTab responseData={responseData} transformedData={transformedData} PlayVideoHandler={PlayVideoHandler} loading={loading} CompLoader={CompLoader} color={color} convertToStandardURL={convertToStandardURL} PlayVimeoVideoHandler={PlayVimeoVideoHandler} />;
      default:
        return <div>Content not available</div>;
    }

  }


  const operationsSlot = {
    left: (
      <div onClick={() => onClickArrow("left")}>
        <img src={leftArrow} alt="main logo" width="auto" />
        <img src={leftArrow} alt="main logo" width="auto" />
      </div>
    ),
    right: (
      <div onClick={() => onClickArrow("right")}>
        <img src={rightArrow} alt="main logo" width="auto" />
        <img src={rightArrow} alt="main logo" width="auto" />
      </div>
    ),
  };

  const slot = useMemo(() => {
    if (position.length === 0) return null;
    return position.reduce(
      (acc, direction) => ({
        ...acc,
        [direction]: operationsSlot[direction],
      }),
      {}
    );
  }, [position, activeKey]);

  const onClickArrow = (direction) => {

    if (activeKey?.length) {
      let siteSettingData = [...siteSetting];
      siteSettingData.push({ id: '123', displayName: 'Contact Us', settingsKey: 'contact-us' },
        { id: '456', displayName: 'About Us', settingsKey: 'about-us' }
      )
      let newTabList = [...tabList];
      newTabList[1] = {
        tabName: siteSettingData[0]?.displayName,
        settingsKey: toKebabCase(siteSettingData[0]?.displayName)?.toLowerCase(),
        tabKey: toKebabCase(siteSettingData[0]?.displayName)?.toLowerCase(),
      }

      const tabIndex = newTabList?.findIndex((item) => toKebabCase(item?.settingsKey) === activeKey?.toLowerCase() || toKebabCase(item?.settingsKey)?.includes(activeKey))
      const index = direction === "right" ? tabIndex + 1 : tabIndex - 1;
      const kebabDisplayName = toKebabCase(newTabList?.[index]?.settingsKey)?.toLowerCase()
      const tabName = newTabList?.find(
        (item) =>
          kebabDisplayName?.startsWith(item.settingsKey) ||
          item.settingsKey?.startsWith(kebabDisplayName) ||
          kebabDisplayName?.includes(item.settingsKey) ||
          item.settingsKey?.includes(kebabDisplayName)
      )?.settingsKey;
      setActiveKey(tabName)
    }

    const currentIndex = proSettingData?.proSettingData.findIndex(tab => toKebabCase(tab?.displayName) === activeKey);
    let newIndex = direction === "left" ? currentIndex - 1 : currentIndex + 1;
    if (newIndex < 0) newIndex = proSettingData?.proSettingData.length - 1;
    if (newIndex >= proSettingData?.proSettingData.length) newIndex = 0;
    setActiveKey(toKebabCase(proSettingData?.proSettingData[newIndex]?.displayName));

  };

  const toKebabCase = str => {
    return str && str
      .replace(/([a-z])([A-Z])/g, '$1-$2') // handle camelCase
      .replace(/\s+|_+/g, '-')             // spaces and underscores to dash
      .replace(/[^\w-]+/g, '')             // remove non-word chars
      .toLowerCase();
  }

  const getCoruselData = async (activeKey, tabKey) => {
    try {
      const tabId = proSettingData?.proSettingData?.find((item) => toKebabCase(item?.displayName) === activeKey?.toLowerCase() || toKebabCase(item?.displayName).includes(activeKey))?.id || localStorage?.getItem('selectedTabId');
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      let response = [];
      if (activeKey == "contact-us") {
        response = await getRequest(
          userServiceApi.getContactUsDetails(contactUsKey, micrositeId),
          { headers }
        );
      }
      if (
        activeKey == "why-work" ||
        activeKey == siteSetting[0]?.displayName ||
        activeKey == "services" ||
        activeKey == "about-us" ||
        activeKey == "courses" ||
        activeKey == "teams-and-roles" ||
        activeKey == "business-card" ||
        activeKey == "home-carousel" ||
        activeKey == "in-the-press" ||
        activeKey == "blog" ||
        activeKey === 'why-work-for-us' ||
        activeKey == "products"

      ) {
        response = await getRequest(
          userServiceApi.getMicrositeDetailsTabs(activeKey, micrositeId, tabId),
          { headers }
        );
      }
      if (activeKey == "apprenticeships") {
        response = await getRequest(
          userServiceApi.getMicrositeDetailsVacancyTab(
            "PART_TIME",
            micrositeId,
            tabId
          ),
          { headers }
        );
      }
      if (activeKey == "vacancies") {
        response = await getRequest(
          userServiceApi.getMicrositeDetailsVacancyTab(
            "FULL_TIME",
            micrositeId,
            tabId
          ),
          { headers }
        );
      }
      if (activeKey == "experiences-of-work") {
        response = await getRequest(
          userServiceApi.getPreviewExperienceofWorkTab(micrositeId),
          { headers }
        );
      }

      if (activeKey == "products") {
        response = await getRequest(
          userServiceApi.getMicrositeDetailsTabs(activeKey, micrositeId, tabId),
          { headers }
        );
      }
      if (activeKey == "contracts") {
        response = await getRequest(
          userServiceApi.getMicrositeDetailsContractTab(micrositeId, tabId),
          { headers }
        );
      }

      setReponseData(response.data);

      setLoading(false);
    } catch (error) {
      toast.error(error.error);
      setLoading(false);
    }
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const transformedData = responseData?.reduce((acc, item) => {
    const teamEntry = acc.find((entry) => entry.assetTitle === item?.assetTitle);
    const itemCopy = {
      id: item?.id,
      title: item?.title,
      subTitle: item?.subTitle,
      available: item?.available,
      description: item?.description,
      type: item?.type,
      mediaLink: {
        id: item?.mediaLink?.id,
        mediaType: item?.mediaLink?.mediaType,
        url: item?.mediaLink?.url,
      },
    };


    if (teamEntry) {
      teamEntry.subTitles.push(itemCopy);
    } else {
      acc.push({
        assetTitle: item?.assetTitle,
        subTitles: [itemCopy],
      });
    }

    return acc;
  }, []);

  useEffect(() => {
    getCoruselData(activeKey);
  }, [activeKey, contactUsKey]);

  useEffect(() => {
    callCData();
  }, []);

  const callCData = async () => {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    try {
      setCLoader(true);
      const getCarouselData = await getRequest(
        userServiceApi.getMicrositeDetailsTabs("corousel", micrositeId, localStorage?.getItem('carouselId')),
        { headers }
      );

      if (getCarouselData && getCarouselData.data) {
        setCData(getCarouselData.data);
        setCLoader(false);
      } else {
        setCLoader(false);
      }
    } catch (error) {
      setCLoader(false);
    }
  };

  const handleConfirmationCancel = () => {
    setSwitchState(microSites[0]?.isPublished);
    setPublishConfirmation(false);
    setUnPublishConfirmation(false);
  };

  const handleConfirmationOk = () => {
    publishHandler(true);
  };

  const unPublishOk = () => {
    publishHandler(false);
  };

  const publishHandler = (value) => {
    if (value) {
      let isPublished = publishMicroSite(data.id, "published");
      setPublishConfirmation(false);
      if (localStorage.getItem("switchSuccess")) {
        if (localStorage.getItem("switchSuccess") === "true") {
          setSwitchState(value);
        } else {
          setSwitchState(!value);
        }
      }
      setTimeout(() => {
        localStorage.removeItem("switchSuccess");
      }, 2000);
      // setSwitchState(true);
    } else {
      let isUnpublished = publishMicroSite(data.id, "unpublished");
      setUnPublishConfirmation(false);
      if (localStorage.getItem("switchSuccess")) {
        if (localStorage.getItem("switchSuccess") === "false") {
          setSwitchState(false);
        } else {
          setSwitchState(true);
        }
      }
      setTimeout(() => {
        localStorage.removeItem("switchSuccess");
      }, 2000);
      // setSwitchState(false);
    }
  };

  const changeTab = (tabValue) => {
    setActiveKey(tabValue);
  };

  const changeContactUsTab = (tabValue) => {
    setContactUsKey(tabValue);
  };

  const handleOk = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  const PlayVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const PlayVimeoVideoHandler = (url, mediaType) => {
    setmediatype(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const handleAfterChange = (index) => {
    // Update the current slide index when the slider changes
    setCurrentSlideIndex(index);
  };

  const filterTab = (key = '') => {
    return siteSetting?.find((item) => item?.displayName?.toLowerCase() === key?.toLowerCase())?.secondaryToggle
  }

  const settings = {
    className: "center",
    centerMode: false,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    speed: 500,
    autoplay: false,
    // autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    // variableWidth: true,
    adaptiveHeight: false,
    afterChange: handleAfterChange,
  };



  return (
    <>
      <Modal
        open={true}
        footer={null}
        onCancel={closeSettings}
        width="25vw"
        className="preview-modal-root"
      >
        <div className="previewContainer">
          <h3>Preview</h3>
          <div className="previewBody">
            <div className="carousel-main">
              <div className="carousel-main-container">
                <div className="corousel-container">
                  <div className="carousel-items">

                    <Slider {...settings}>
                      {carouselData &&
                        carouselData?.map((data, i) => {
                          if (i < 4) {
                            if (
                              data?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                              data.mediaLink.url
                            ) {
                              return (
                                <div>
                                  <div className="slide">
                                    <ReactPlayer
                                      controls={true}
                                      url={data.mediaLink.url}

                                      height="150px"
                                      width="100%"

                                    ></ReactPlayer>
                                    {i === currentSlideIndex ? (
                                      <div
                                        style={{
                                          width: "100%",
                                          display: "flex",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <label
                                          className="slider-label"
                                          style={{ fontWeight: "bold" }}
                                        >
                                          {data.title}
                                        </label>
                                      </div>
                                    ) : null}
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    ></div>
                                  </div>
                                  <div></div>
                                </div>
                              );
                            } else if (
                              data?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                              data.mediaLink.url
                            ) {
                              return (
                                <div className="slide video">
                                  <iframe
                                    controls={true}
                                    src={data.mediaLink.url}

                                    height="150px"
                                    width="100%"
                                    style={{ backgroundColor: "black" }}
                                  />
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {data.title}
                                    </label>
                                  </div>
                                </div>
                              );
                            } else {
                              return (
                                <div className="slide">
                                  <div className="img-slide">
                                    <img
                                      style={{
                                        height: "150px",
                                        width: "100%",
                                        objectFit: "cover",
                                      }}
                                      src={data?.mediaLink?.url}
                                      alt=""
                                      className="c1 carousel-image"
                                    />
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <label
                                        style={{
                                          marginLeft: "auto",
                                          marginRight: "auto",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {data.title}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          }
                        })}
                    </Slider>
                  </div>
                </div>
              </div>{" "}
            </div>
            <Tabs
              className="preview-tabs"
              tabBarExtraContent={slot}
              type="card"
              activeKey={activeKey}
              onChange={changeTab}
              items={proSettingData?.proSettingData
                ?.filter(
                  (item) =>
                    item.displayName !== "Business card" &&
                    item.displayName !== "Home carousel"
                )
                .map((item) => ({
                  key: toKebabCase(item.displayName),
                  label: (
                    <span style={{ fontWeight: "bold" }}>
                      {item.displayName}
                    </span>
                  ),
                  children: renderTabContent(toKebabCase(item.displayName)),
                }))}
            />

          </div>
          <div className="preview-footer">
            {data && (
              <Switch
                checked={switchState}
                defaultChecked={data?.isPublished}
                checkedChildren="Online"
                unCheckedChildren="Offline"
                onChange={(e) => {
                  if (e) {
                    setPublishConfirmation(true);
                  } else {
                    setUnPublishConfirmation(true);
                  }
                }}
              />
            )}
          </div>
          <Modal
            open={isModalOpen}
            footer={null}
            onOk={handleOk}
            onCancel={handleCancel}
            width={350}
            destroyOnClose={true}
          >

            {mediatype === "SOCIAL_MEDIA" ? (
              <div className="preview-secondary-player">
                <ReactPlayer
                  controls={true}
                  url={videoUrl}
                  height="100%"
                  width="100%"
                ></ReactPlayer>
              </div>
            ) : (
              <div className="preview-secondary-player">
                <VimeoPlayer
                  controls={true}
                  url={videoUrl}
                  height="100%"
                  width="100%"
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nofullscreen",
                      },
                    },
                  }}
                ></VimeoPlayer>
              </div>
            )}
          </Modal>
        </div>
      </Modal>
      <Modal
        className="confirmation-modal"
        destroyOnClose={true}
        closable={false}
        footer={null}
        open={publishConfirmation}
        onOk={handleConfirmationOk}
        onCancel={handleConfirmationCancel}
      >
        <div className="message">Are you sure you want to go online?</div>
        <div className="modalBtns">
          <Button className="cancel-btn" type="primary" onClick={handleConfirmationCancel}>
            Cancel
          </Button>
          <Button className="confirm-btn" key="back" onClick={handleConfirmationOk}>
            Publish
          </Button>
        </div>
      </Modal>
      <Modal
        className="confirmation-modal"
        destroyOnClose={true}
        closable={false}
        footer={null}
        open={unPublishConfirmation}
        onOk={unPublishOk}
        onCancel={handleConfirmationCancel}
      >
        <div className="message">Are you sure you want to go offline?</div>
        <div className="modalBtns">
          <Button className="confirm-btn" key="back" onClick={unPublishOk}>
            Unpublish
          </Button>
          <Button className="cancel-btn" type="primary" onClick={handleConfirmationCancel}>
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Preview;
